import React, { useState } from 'react';

interface TruncateTextCompProps {
    text?: string;
    maxLength?: number;
    showScrollbar?: boolean; // new flag
}

const TruncateTextComp: React.FC<TruncateTextCompProps> = ({
    text = "",
    maxLength = 500,
    showScrollbar = false
}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        setIsExpanded(prev => !prev);
    };

    const shouldTruncate = text.length > maxLength;
    const displayedText =
        isExpanded || !shouldTruncate ? text : text.slice(0, maxLength) + "...";

    return (
        <div className="position-relative w-100">
            <p
                style={{
                    whiteSpace: "pre-line",
                    maxHeight: isExpanded && showScrollbar ? "9em" : "none", // ~6 lines (1.5em per line)
                    overflowY: isExpanded && showScrollbar ? "auto" : "visible",
                }}
                className={`m-0 ${
                    !isExpanded && shouldTruncate ? "description-blur" : ""
                }`}
            >
                {displayedText}
            </p>

            {shouldTruncate && (
                <div className="text-end">
                    <a
                        href="#"
                        onClick={toggleExpanded}
                        className="text-decoration-none text-dark"
                    >
                        {isExpanded ? "See less" : "See more"}
                    </a>
                </div>
            )}
        </div>
    );
};

export default TruncateTextComp;
